<script setup lang="ts">
import { computed } from 'vue'
import successIcon from '@/assets/icons/blog/success-form.svg'

interface TSendContent {
    title: string
    description: string
    buttonTitle?: string
    buttonUrl?: string
}

const props = defineProps<{
    data: TSendContent
    type: 'success' | 'error' | null
}>()

defineEmits(['closeMessage'])

const showIcon = computed(() => props.type === 'success')
</script>

<template>
    <section class="plus-stettings bg-plus-blue-500">
        <button
            class="ml-auto flex cursor-pointer py-3 pr-3"
            @click="$emit('closeMessage')"
        >
            <span
                class="plus-stettings close size-5"
                tabindex="0"
            />
        </button>
        <div class="msg-box py-8">
            <div class="w-full px-3 text-center">
                <AtomImage
                    v-if="showIcon"
                    :src="successIcon"
                    img-class="mx-auto"
                />
                <h2
                    v-if="props.data.title"
                    class="mb-5 mt-10 text-2xl font-bold"
                    v-html="props.data?.title"
                />
                <p
                    v-if="props.data.description"
                    class="copy mx-auto"
                    v-html="props.data?.description"
                />
                <NuxtLink
                    v-if="props.type === 'error'"
                    :to="props.data?.buttonUrl"
                    class="mx-auto mt-7 flex h-12 w-full items-center justify-center rounded-3xl bg-plus-primary text-plus-secondary md:w-[85%]"
                >
                    {{ props.data?.buttonTitle }}
                </NuxtLink>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.close::after {
    content: '+';
    display: flex;
    justify-content: flex-end;
    align-items: center;
    transform: rotate(45deg);
    line-height: 34px;
    font-size: 40px;
    font-weight: 700;
    width: 20px;
    height: 20px;
}
.msg-box {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    .copy {
        max-width: 37ch;
    }
}
</style>
